<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Transición de Estados para la Unidad de Inspección de Campañas</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos de la Transición de Estados para la Unidad de Inspección de Campañas
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpPerfil">Perfil del usuario</label>

                                        <ng-select [items]="listPerfilesUsuario"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPerfilUsuario"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listPerfilesUsuario)"
                                                   notFoundText="Perfil no encontrado"
                                                   placeholder="-- Seleccione un Perfil --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPerfilUsuario')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPerfilUsuario','required')">
                                            El Perfil del usuario es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpTipoInspeccionCam">Tipo de Inspección</label>

                                        <ng-select [items]="listTiposInspeccionCam"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdTipoInspeccionCam"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listTiposInspeccionCam)"
                                                   notFoundText="Tipo de inspección no encontrado"
                                                   placeholder="-- Seleccione un Tipo de inspección --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdTipoInspeccionCam')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoInspeccionCam','required')">
                                            El Tipo de Inspección es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpEstado">Estado de la Unidad de Inspección</label>

                                        <ng-select [items]="listEstadosUnidadInspeccionCam"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdEstadoUnidadInspeccionCam"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listEstadosUnidadInspeccionCam)"
                                                   notFoundText="Estado no encontrado"
                                                   placeholder="-- Seleccione un Estado --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdEstadoUnidadInspeccionCam')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdEstadoUnidadInspeccionCam','required')">
                                            El Estado de la Unidad de Inspección es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpResultado">Resultado de la Inspección</label>

                                        <ng-select [items]="listResultadosInspeccionCam"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdResultadoInspeccionCam"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listResultadosInspeccionCam)"
                                                   notFoundText="Resultado no encontrado"
                                                   placeholder="-- Seleccione un Resultado --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdResultadoInspeccionCam')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdResultadoInspeccionCam','required')">
                                            El Resultado de la Inspección es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpEstado">Siguiente Estado de la Unidad de Inspección</label>

                                        <ng-select [items]="listEstadosUnidadInspeccionCam"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdSiguienteEstadoUnidadInspeccionCam"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listEstadosUnidadInspeccionCam)"
                                                   notFoundText="Estado no encontrado"
                                                   placeholder="-- Seleccione el siguiente Estado --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdSiguienteEstadoUnidadInspeccionCam')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdSiguienteEstadoUnidadInspeccionCam','required')">
                                            El Siguiente Estado de la Unidad de Inspección es obligatorio
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
